import { render, staticRenderFns } from "./AccessoriesForm.vue?vue&type=template&id=1b8eb076&scoped=true"
import script from "./AccessoriesForm.vue?vue&type=script&lang=js"
export * from "./AccessoriesForm.vue?vue&type=script&lang=js"
import style0 from "./AccessoriesForm.vue?vue&type=style&index=0&id=1b8eb076&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8eb076",
  null
  
)

export default component.exports